import { isElementNode } from '../helpers';

/**
 * Builds a map from 'key' attribute values to their corresponding elements and indices.
 * @param {Array<Node>} elements
 * returns {Map<string, { element: Node; index: number }>}
 */
export const buildKeyMap = (
    elements: ReadonlyArray<Node>
): Map<string, { element: Node; index: number }> => {
    const map = new Map<string, { element: Node; index: number }>();
    elements.forEach((element, index) => {
        if (isElementNode(element)) {
            const key = element.getAttribute('key') ?? '';
            if (key.trim()) {
                if (map.has(key)) {
                    console.warn(
                        `Duplicate key found: "${key}". Using last occurrence.`
                    );
                }
                map.set(key, { element, index });
            }
        }
    });
    return map;
};
